import React, { useEffect, useState } from 'react';
import { startBuildUpdateCheck } from '../utils/buildUpdateCheck';
import { isBuildUpdateSnoozed, snoozeBuildUpdate } from '../utils/buildUpdateSnooze';

const HOUR = 60 * 60 * 1000;
const SNOOZE_OPTIONS = [
	{ label: '1 hour', ms: 1 * HOUR },
	{ label: '3 hours', ms: 3 * HOUR },
	{ label: '24 hours', ms: 24 * HOUR },
];

const bannerStyle = {
	position: 'fixed',
	top: 0,
	left: 0,
	right: 0,
	zIndex: 10050,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexWrap: 'wrap',
	gap: '12px',
	padding: '10px 16px',
	background: '#1a3a5c',
	color: '#fff',
	fontSize: '14px',
	boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
};

export default function BuildUpdateBanner() {
	const [buildId, setBuildId] = useState(null);

	useEffect(() => startBuildUpdateCheck((nextId) => {
		if (!isBuildUpdateSnoozed(nextId)) {
			setBuildId(nextId);
		}
	}), []);

	if (!buildId) return null;

	const snooze = (ms) => {
		snoozeBuildUpdate(buildId, ms);
		setBuildId(null);
	};

	return (
		<div style={bannerStyle} role="status">
			<span>A new version of iPacket Recon is available.</span>
			<button
				type="button"
				className="btn btn-sm btn-light"
				onClick={() => window.location.reload()}
			>
				Reload
			</button>
			<span style={{ opacity: 0.85 }}>Snooze:</span>
			{SNOOZE_OPTIONS.map(({ label, ms }) => (
				<button
					key={label}
					type="button"
					className="btn btn-sm btn-outline-light"
					onClick={() => snooze(ms)}
				>
					{label}
				</button>
			))}
		</div>
	);
}
